import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const WA_LINK =
  "https://wa.me/919661968613?text=Hello%20Taste%20Ride%20team%2C%20I%27d%20like%20to%20discuss%20investment%20and%20partnership%20opportunities.";

export const scrollToId = (id) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(`#${id}`, { offset: -64, duration: 1.5 });
  } else {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const FadeUp = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.85, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const ChapterTag = ({ index, label, dark = true }) => (
  <FadeUp className="flex items-center gap-4">
    <span
      className={`flex h-9 w-9 items-center justify-center rounded-full font-mono text-xs font-semibold ${
        dark ? "bg-flame text-cream" : "bg-obsidian text-saffron"
      }`}
    >
      {index}
    </span>
    <span
      className={`font-mono text-xs font-medium uppercase tracking-[0.3em] ${
        dark ? "text-saffron" : "text-flame"
      }`}
    >
      {label}
    </span>
    <span className={`h-px flex-1 ${dark ? "bg-white/10" : "bg-obsidian/10"}`} />
  </FadeUp>
);
